import React from 'react';
import { FieldLayout } from './FieldLayout';

export const Field = () => <FieldLayout />;
